import React from "react";
import { Box } from "@mui/material";

const YouTubeEmbed = ({ videoId }) => {
  return (
    <Box
      className="backgroundDots"
      sx={{
        width: "100%",

        height: "100%",
        position: "relative",
        margin: "0 auto",
      }}
    >
      <Box
        component="iframe"
        src={`https://www.youtube.com/embed/${videoId}`}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="YouTube video"
        sx={{
          position: "absolute",
          inset: 0,
          padding: 3,
          aspectRatio: "16 / 9",
          width: "85%",
          height: "100%",
          border: 0,
          margin: "0 auto",
        }}
      />
    </Box>
  );
};

export default YouTubeEmbed;
